import React from 'react';
import { Question } from '../../types/game';
import { useTheme } from '../../contexts/ThemeContext';
import { Card } from '../ui/Card';
import { Text } from '../ui/Text';

interface ReadingScreenProps {
  question: Question;
  secondsLeft: number;
}

const ReadingScreen: React.FC<ReadingScreenProps> = ({ question, secondsLeft }) => {
  const { theme } = useTheme();

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-4xl w-full">
        <div className="text-center mb-8">
          <div className="text-7xl mb-4 animate-pulse">📖</div>
          <Text as="h2" size="4xl" weight="bold" color="primary" align="center" className="mb-4 drop-shadow-lg">
            Read Carefully!
          </Text>
          <Text size="2xl" weight="semibold" color="onSurfaceVariant" align="center">
            Question {question.index} of {question.total}
          </Text>
        </div>

        <Card
          variant="solid"
          elevation="xl"
          padding="lg"
          className="mb-6"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
          }}
        >
          <Text
            as="h3"
            size="4xl"
            weight="bold"
            align="center"
            className="leading-relaxed"
            style={{
              color: '#1a1a1a',
            }}
          >
            {question.text}
          </Text>
        </Card>

        <div className="text-center">
          <div
            className="inline-flex items-center px-8 py-4 rounded-full shadow-xl"
            style={{
              background: theme.colors.info,
              color: theme.colors.onPrimary,
              backdropFilter: 'blur(8px)',
            }}
          >
            <span className="text-3xl mr-3">🔒</span>
            <Text as="p" size="2xl" weight="bold" style={{ color: theme.colors.onPrimary }}>
              Answer in {secondsLeft}s...
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadingScreen;
